<div class="wrapper" [class.loading]="!display">
    <img #image [attr.src]="source" />
</div>
